import useMfe from './use-mfe.hook'

export default useMfe
